import { useQuery } from '@tanstack/react-query';
import { ProviderReferenceHolder } from 'src/financial/financial-data/providerReferenceHolders';

type ProviderReferenceSharing = {
  holders: ProviderReferenceHolder[];
  needs_review: boolean;
  cannot_be_joint: boolean;
};

export const useProviderReferenceSharing = (clientId: string, assetId: string) =>
  useQuery<ProviderReferenceSharing>({
    queryKey: ['clients', clientId, 'assets', assetId, 'provider-reference-sharing'],
    enabled: !!clientId && !!assetId,
  });
